import axios from "axios"
import { getField, updateField } from 'vuex-map-fields'

const defaultState = {
  poa: {
    activated: true, // changed on 2021-11-25 on Johan's request
    isValid: true,
    processing: true,
    authorization_id: '',
    id: '', // id: "hNJErZyYr2JHdEZ2XQzQ5zXH"
    owner_sign_link: '', // owner_sign_link: "http://localhost:3000/session/sk16tK8xvLtZu92JhVaDvMtN"
    status: '', // Created/...
    locale: '', // locale: "en"
  }
}

const actions = {
  postEnvelope(context) {
    if (!context.state.poa.processing) {
      context.commit('updateField', { path: `poa.processing`, value: true })
      // TODO yar check this promise
      return new Promise((resolve, reject) => {
        axios.post('/signseal/create_temp_envelope', {
          poa: {
            complaint_id: context.getters.complaintId
          },
        }).then((response) => {
          if (response.data.success) {
            context.commit('FETCH_POA', response.data.envelope)
            resolve()
          } else {
            reject(`POA creation isn't successful with error: ${response.data.error}`)
          }
        }).catch((errors) => {
          reject(`POA creation errors: ${errors}`)
        }).then(() => {
          context.commit('updateField', { path: `poa.processing`, value: false })
        })
      })
    }
  }
}

const getters = {

  getField,

  complaintId: (state, getters, rootState) => {
    return rootState.round2.complaint.id
  },

  owner_sign_link: (state) => {
    return `${state.poa.owner_sign_link}?widget=true`//.replace('localhost', '192.168.0.101')
  },

  isNoEnvelope: (state) => {
    return !state.poa.processing && // no processing
      !state.poa.owner_sign_link  // no envelope yet
  },

  isActualEnvelope: (state) => {
    return !state.poa.processing && // no processing
      !!state.poa.owner_sign_link // envelope exists
  },

  isCompletedEnvelope: (state, getters) => {
    return getters.isActualEnvelope && state.poa.status == 'Completed'
  },

  isntActualEnvelope: (state) => {
    return !state.poa.processing && // no processing
      !!state.poa.owner_sign_link // envelope exists
  }
}

const mutations = {

  updateField,

  RESET_STORE(state) {
    Object.assign(state, defaultState)
  },

  FETCH_POA(state, envelope) {
    if (envelope){
      state.poa.processing = false
      state.poa.owner_sign_link = envelope.sign_owner_url
      state.poa.authorization_id = envelope.authorization_id
      state.poa.id = envelope.id
      state.poa.status = envelope.status
    }
  }
}

export default {
  namespaced: true,
  state: defaultState,
  actions: actions,
  getters: getters,
  mutations: mutations
}
